import debounce from 'lodash.debounce';
import Layout from './layout';

export default class SiteHeader extends HTMLElement {
  constructor() {
    super();
    this.layout = Layout.getInstance();
    this.headerEl = this.querySelector('header');
    this.subheaderEl = this.querySelector('[data-subheader]');
    this.body = document.querySelector('body');
    this.subMenus = this.querySelectorAll('[data-submenu]');
    this.overlay = this.querySelector('[data-nav-overlay]');
    this.expandableMenus = this.querySelectorAll('[data-nav-item]');
    this.expandableButtons = this.querySelectorAll('[data-nav-button]');
    this.mobileMenuTrigger = this.querySelector('[data-mobile-menu-trigger]');
    this.closeMenuButtons = this.querySelectorAll('[data-nav-close]');
    this.mobileBackButtons = this.querySelectorAll('[data-nav-back]');
    this.promoBanner = document.querySelector('#shopify-section-dynamic-banner');
    this.toggleMobileMenu = this.toggleMobileMenu.bind(this);
    this.closeMobileMenu = this.closeMobileMenu.bind(this);
    this.closeExpandedNavs = this.closeExpandedNavs.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
    this.updateDesktopHeaderHeight = this.updateDesktopHeaderHeight.bind(this);
  }

  connectedCallback() {
    this.registerMobileMenuListeners();
    this.registerExpandableButtonListeners();
    this.registerEscapeKeyHandler();
    this.registerOverlayListeners();
    this.setHeaderHeight();

    window.addEventListener('bpChange', () => {
      this.registerMobileMenuListeners();
      this.registerEscapeKeyHandler();
    });

    window.onload = this.updateDesktopHeaderHeight;
  }

  disconnectedCallback() {
    this.closeMenuButtons.forEach((button) => button.removeEventListener('click', this.closeMobileMenu));
    this.mobileBackButtons.forEach((button) => button.removeEventListener('click', this.closeExpandedNavs));
    document.removeEventListener('keyup', this.handleCloseMenu);
  }

  registerMobileMenuListeners() {
    if (this.layout.isBelowBreakpoint('lg')) {
      if (this.mobileListening) return;
      this.mobileListening = true;
      this.mobileMenuTrigger.addEventListener('click', this.toggleMobileMenu);
      this.closeMenuButtons.forEach((button) => button.addEventListener('click', this.closeMobileMenu));
      this.mobileBackButtons.forEach((button) => button.addEventListener('click', this.closeExpandedNavs));
    } else {
      this.closeMobileMenu();
      if (!this.mobileListening) return;
      this.mobileMenuTrigger.removeEventListener('click', this.toggleMobileMenu);
      this.closeMenuButtons.forEach((button) => button.removeEventListener('click', this.closeMobileMenu));
      this.mobileBackButtons.forEach((button) => button.removeEventListener('click', this.closeExpandedNavs));
      this.mobileListening = false;
    }
  }

  toggleMobileMenu() {
    this.body.classList.toggle('open-menu');
  }

  closeMobileMenu() {
    this.body.classList.remove('open-menu');
    this.expandableButtons.forEach((button) => button.parentElement.classList.remove('expanded'));
    this.body.classList.remove('open-submenu');
  }

  closeExpandedNavs() {
    this.expandableButtons.forEach((button) => button.parentElement.classList.remove('expanded'));
    this.body.classList.remove('open-submenu');
  }

  handleCloseMenu(e) {
    if (e.keyCode === 27) {
      this.expandableMenus.forEach((menu) => menu.classList.remove('expanded'));
    }
  }

  registerExpandableButtonListeners() {
    const handleExpandableButtons = (button) => {
      this.expandableButtons.forEach((expandableButton) => {
        if (expandableButton === button) {
          expandableButton.parentElement.classList.toggle('expanded');
          if (this.layout.isBelowBreakpoint('lg')) {
            this.body.classList.add('open-submenu');
          }
        } else {
          expandableButton.parentElement.classList.remove('expanded');
        }
      });
    };

    this.expandableButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (this.layout.isBelowBreakpoint('lg')) {
          handleExpandableButtons(button);
        }
      });

      button.addEventListener('keydown', (e) => {
        if (this.layout.isAboveBreakpoint('lg') && e.keyCode === 13) {
          handleExpandableButtons(button);
        }
      });
    });
  }

  registerEscapeKeyHandler() {
    if (this.layout.isAboveBreakpoint('lg')) {
      if (this.escapeListening) return;
      this.escapeListening = true;
      document.addEventListener('keyup', this.handleCloseMenu);
    } else {
      if (!this.escapeListening) return;
      document.removeEventListener('keyup', this.handleCloseMenu);
      this.escapeListening = false;
    }
  }

  registerOverlayListeners() {
    [...this.expandableMenus, ...this.subMenus].forEach((menu) => {
      menu.addEventListener('mouseover', () => {
        this.overlay.classList.remove('hidden');
        menu.setAttribute('aria-expanded', 'true');
      });
      menu.addEventListener('mouseleave', () => {
        this.overlay.classList.add('hidden');
        menu.setAttribute('aria-expanded', 'false');
      });
    });
  }

  updateDesktopHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.headerEl.getBoundingClientRect().bottom}px`);
  }

  setHeaderHeight() {
    if (this.layout.isBelowBreakpoint('lg')) {
      this.style.setProperty('--header-height', `${this.subheaderEl.offsetHeight}px`);
    } else {
      const debouncedUpdateHeaderHeight = debounce(this.updateDesktopHeaderHeight, 250);
      this.updateDesktopHeaderHeight();
      window.addEventListener('resize', debouncedUpdateHeaderHeight);
      window.addEventListener('scroll', debouncedUpdateHeaderHeight);
    }
  }
}
customElements.define('site-header', SiteHeader);
